module.exports = __webpack_public_path__ + "files/98209f1082f715e66ea98c91bb1273e4.png";